import dbaIllustration1 from './dba/dbaIllustration1';
import dbaIllustration2 from './dba/dbaIllustration2';
import dbaIllustration3 from './dba/dbaIllustration3';
import dbaIllustration4 from './dba/dbaIllustration4';
import toriIllustration1 from './tori/toriIllustration1';
import toriIllustration2 from './tori/toriIllustration2';
import toriIllustration3 from './tori/toriIllustration3';
import toriIllustration4 from './tori/toriIllustration4';

const illustrationsByBrand = {
  dba: [dbaIllustration1, dbaIllustration2, dbaIllustration3, dbaIllustration4],
  tori: [toriIllustration1, toriIllustration2, toriIllustration3, toriIllustration4],
};

export function getOnboardingIllustrations(brand) {
  const normalizedBrand = brand.toLowerCase();
  
  if (illustrationsByBrand[normalizedBrand]) {
      return illustrationsByBrand[normalizedBrand].reduce((acc, illustration, index) => {
          acc[`illustration${index + 1}`] = illustration;
          return acc;
      }, {});
  }
  return undefined;
}

